module.exports = __webpack_public_path__ + "static/media/手写数字识别.06caf300.png";